import isMiniFeatureEnabled from 'owa-mini-feature-flags/lib/isMiniFeatureEnabled';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

/**
 * Determines if the host app needs to be blocked for user.
 *
 * As of now, we are blocking only Outlook Lite app when specifically asked by a tenant.
 * This is driven via a custom feature flight ('lite-block-tenant') and not via any tenant config.
 * We are also using an internal flag ('allowTenantBlocking') to indicate if tenant blocking is enabled by the host app.
 */
export const tenantBlockCondition = (): boolean =>
    isMiniHostAppFeatureEnabled('allowTenantBlocking') && isMiniFeatureEnabled('lite-block-tenant');
